import React from 'react'
import { MONTH_NAMES, AVAILABLE_YEARS } from './constants'

const KAMFilters = ({
  selectedMonth,
  selectedYear,
  selectedOperator,
  operatorOptions,
  onMonthChange,
  onYearChange,
  onOperatorChange,
  showOperatorFilter = true
}) => {
  const now = new Date()
  
  const handleQuickSelect = (e) => {
    const value = e.target.value
    if (value === 'current') {
      onMonthChange(now.getMonth() + 1)
      onYearChange(now.getFullYear())
    } else if (value === 'previous') {
      const prevMonth = now.getMonth() === 0 ? 12 : now.getMonth()
      const prevYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()
      onMonthChange(prevMonth)
      onYearChange(prevYear)
    }
  }

  return (
    <div className="bg-white p-5 rounded-xl border border-gray-200 mb-6">
      <h3 className="text-base font-semibold text-gray-700 mb-4 flex items-center">
        <i className="fa-regular fa-calendar-days mr-2"></i>
        Wybór Miesiąca
      </h3>
      <div className={`grid gap-4 ${showOperatorFilter ? 'grid-cols-4' : 'grid-cols-3'}`}>
        {/* Quick Select */}
        <div>
          <label htmlFor="quick-select" className="block text-xs font-medium text-gray-600 mb-1">
            Szybki wybór
          </label>
          <select
            id="quick-select"
            onChange={handleQuickSelect}
            className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            defaultValue="custom"
          >
            <option value="custom">Własny wybór</option>
            <option value="current">Bieżący miesiąc</option>
            <option value="previous">Poprzedni miesiąc</option>
          </select>
        </div>

        {/* Month Select */}
        <div>
          <label htmlFor="month-select" className="block text-xs font-medium text-gray-600 mb-1">
            Miesiąc
          </label>
          <select
            id="month-select"
            value={selectedMonth}
            onChange={(e) => onMonthChange(parseInt(e.target.value))}
            className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {MONTH_NAMES.map((name, idx) => (
              <option key={idx + 1} value={idx + 1}>{name}</option>
            ))}
          </select>
        </div>

        {/* Year Select */}
        <div>
          <label htmlFor="year-select" className="block text-xs font-medium text-gray-600 mb-1">
            Rok
          </label>
          <select
            id="year-select"
            value={selectedYear}
            onChange={(e) => onYearChange(parseInt(e.target.value))}
            className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {AVAILABLE_YEARS.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        {/* Operator Filter */}
        {showOperatorFilter && (
          <div>
            <label htmlFor="operator-filter" className="block text-xs font-medium text-gray-600 mb-1">
              Filtruj według operatora
            </label>
            <select
              id="operator-filter"
              value={selectedOperator}
              onChange={(e) => onOperatorChange(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {operatorOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  )
}

export default KAMFilters


